import React from 'react';
import { useParams } from 'react-router-dom';
import CompanyProfileDisplay from '../components/CompanyProfileDisplay';

const CompanyDetail = () => {
  const { companyId } = useParams();

  return (
    <div className="min-h-screen bg-gray-50">
      <CompanyProfileDisplay companyId={companyId} />
    </div>
  );
};

export default CompanyDetail;
